export default __webpack_public_path__ + "static/media/ant1.727ebea5.jpg";